import {unflatten} from 'flat';
import validatorjs from 'validatorjs';
import moment from 'moment';
import {validationErrors} from './lang';
import _ from 'lodash/fp';

validatorjs.setMessages('se', validationErrors);
validatorjs.useLang('se');

validatorjs.register(
  'archivable',
  (value, requirement, attribute) =>
    _.isBoolean(value) || moment(value, moment.ISO_8601).isValid(),
  validationErrors.archivable);

const mapRules =
  _.mapValues('rule');

const mapLabels =
  _.mapValues('label');

export default (validation, data) => {
  const rules = mapRules(validation);
  const attributes = mapLabels(validation);

  const validator = new validatorjs(data, rules);
  validator.setAttributeNames(attributes);
  validator.passes();
  return unflatten(validator.errors.all());
};



// WEBPACK FOOTER //
// ./src/helpers/validator.js